export enum OnboardingMode {
  AWS = 'backup_ub_aws',
  Wasabi = 'backup_ub_wasabi',
  AppsAWS = 'apps_ub_aws',
  AppsWasabi = 'apps_ub_wasabi',
  RA = 'remote_desktop',
  RA_PE = 'remote_desktop_pe',
  Rmm = 'rmm',
  RmmCE = 'rmm_ce',
  RmmPe = 'rmm_pe',
  RmmPeCE = 'rmm_pe_ce',
  TryRmm = 'try-rmm',
  SkipWizard = 'skipWizard',
  B2 = 'b2_only',
  IDrive = 'idrive_only',
  RmmScripts = 'rmm_script_library',
  RmmScriptsPe = 'rmm_script_library_pe'
}
